<template>
  <div class="editor_box">
    <div :id="name"></div>
  </div>
</template>

<script>
import wEditor from 'wangeditor'
import api from '@/services/api'


export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  data() {
    return {
      name: 'editor' + (Math.random() * 10000000000).toFixed(0),
      editor: null,
      content: '',
      $refType: 'editor',
    }
  },
  watch: {
    // 监听数据变化，及时提交给父组件
    content: {
      deep: true,
      immediate: true,
      handler: function (newV) {
        this.$emit('change', newV);
      }
    },
    value: {
      immediate: true,
      handler: function (val) {
        if (val && val !== this.content) {
          this.editor.txt.html(val);
          // this.content = val;
        }
      }
    },
    disabled: {
      immediate: false,
      handler: function (val) {
        if (val) {
          this.editor.disable();
        } else {
          this.editor.enable();
        }
      }
    }
  },
  props: {
    value: {
      type: String
      // 这个参数是v-decorator给子组件传值用的
      // 这里不要给默认值， 在form下使用会爆警告 Warning: SquareUpload `default value` can not collect,  please use `option.initialValue` to set default value.
    },
    //富文本标识
    editorId: String,
    //富文本配置项
    editorConfig: Object,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    const editor = new wEditor(`#${this.name}`);
    let vm = this;

    //填充配置 新配置>预设>默认
    Object.assign(editor.config, {
      placeholder: '',
      menus: ['undo', 'redo', 'head', 'bold', 'fontSize', 'fontName', 'italic', 'underline', 'strikeThrough', 'indent', 'lineHeight', 'foreColor', 'backColor', 'list', 'link', 'todo', 'justify', 'quote', 'emoticon', 'image', 'table', 'code', 'splitLine',],//设置菜单
      excludeMenus: [],//设置不需要的菜单
      emotions: [//表情 可使用图片自定义表情包 type 为image
        {
          title: 'emoji',  // tab 的标题
          type: 'emoji', // 'emoji' / 'image'
          // emoji 表情，content 是一个数组即可
          content: '😀 😃 😄 😁 😆 😅 😂 😊 😇 🙂 🙃 😉 😓 😪 😴 🙄 🤔 😬 🤐'.split(/\s/),
        },
      ],
      showFullScreen: false,//是否显示全屏

      onchangeTimeout: 300,//监听onchange的节流时间
      onchange(val) {
        vm.content = val;
        // vm.$emit('changeEditorVal', vm.editorId, val);
      },
      showLinkImg: false,
      // linkImgCallback() {
      //   console.log()
      //   return vm.$message.error('图片链接有误')
      // },
      linkImgCheck(url) {
        let isTrue = false;
        for (let i = 0; i < this.uploadImgAccept.length; i++) {
          if (url.includes('http') && url.includes(this.uploadImgAccept[i])) {
            isTrue = true;
            break;
          }
        }
        if (!isTrue) {
          vm.$message.error('请输入图片链接，且图片类型为：' + this.uploadImgAccept.join(','));
          return undefined
        } else {
          return true
        }
      },

      //上传图片相关
      uploadImgShowBase64: false,//以base64 上传 与uploadImgServer不共存

      uploadImgServer: api.temp.UPLOAD_PATH,//服务器地址
      uploadImgMaxSize: 2 * 1024 * 1024, // 上传图片大小 单位b
      uploadImgAccept: ['jpg', 'jpeg', 'png', 'gif', 'bmp'],//上传图片类型
      uploadImgMaxLength: 1, // 一次最多上传 5 个图片
      // uploadImgParams: {//其他参数
      //   token: 'asdasdasda'
      // },
      uploadFileName: 'file',
      uploadImgHooks: {//回调和监听函数
        // 上传图片之前
        before: function (xhr) {
          console.log(xhr)

          // 可阻止图片上传
          // return {
          //   prevent: true,
          //   msg: '需要提示给用户的错误信息'
          // }
        },
        // 图片上传并返回了结果，图片插入已成功
        success: function (xhr) {
          console.log('success', xhr)
        },
        // 图片上传并返回了结果，但图片插入时出错了
        fail: function (xhr, editor, resData) {
          console.log('fail', resData)
        },
        // 上传图片出错，一般为 http 请求的错误
        error: function (xhr, editor, resData) {
          console.log('error', xhr, resData)
        },
        // 上传图片超时
        timeout: function (xhr) {
          console.log(xhr, 'timeout')
        },
        // 图片上传并返回了结果，想要自己把图片插入到编辑器中
        // 例如服务器端返回的不是 { errno: 0, data: [...] } 这种格式，可使用 customInsert
        customInsert: function (insertImgFn, result) {
          // result 即服务端返回的接口
          console.log('customInsert', result)

          // insertImgFn 可把图片插入到编辑器，传入图片 src ，执行函数即可
          insertImgFn(api.temp.FILE_PATH + result.data.url)
        }
      },
    }, this.editorConfig);

    // 创建编辑器
    editor.create();
    this.editor = editor;

    // this.$nextTick(()=>{
    //   let dom = document.querySelectorAll('#'+this.name +' .w-e-text');
    //   let event = new Event('focus');
    //   setTimeout(()=>{
    //
    //   dom.dispatchEvent(event);
    //   },500)
    // })

  },
  methods: {
    /**
     * 获取富文本的值
     * @param type  需要获取的类型 默认为所有 text获取文本 html 获取html代码格式
     */
    getEditorData(type = 'html') {
      if (type === 'html') {
        return this.editor.txt.html();
      } else {
        return this.editor.txt.text();
      }
    },

    /**
     * 设置富文本的值 通用写法
     * @param val
     */
    setFormChangeData(val) {
      this.editor.txt.html(val);
    },

    /**
     * 设置富文本的值
     * @param val
     */
    setEditorData(val) {
      this.editor.txt.html(val);
    },
    /**
     * 追加富文本的值
     * @param val
     */
    appendEditorData(val) {
      this.editor.txt.append(val);
    },
    /**
     * 清空富文本内的值
     * @param val
     */
    clearEditorData(val) {
      this.editor.txt.clear(val);
    },
  },
  beforeDestroy() {
    // 组件销毁时自动销毁富文本
    this.editor.destroy();
    this.editor = null;
  },
}
</script>

<style lang="less">
</style>